<template>
    <button @click="togglePlayPause()"
            :class="{
                'pp-ui-button': applyStyles,
                'pp-ui-button-pause': applyStyles && playing,
                'pp-ui-button-play': applyStyles && !playing,
             }">
        <slot name="play" v-if="!playing">
            <Play />
        </slot>
        <slot name="pause" v-else>
            <Pause />
        </slot>
    </button>
</template>

<script>
  import {PPComponentMixin, PPPlayerMethodsMixin} from "../mixins";
  import Play from '../style/assets/play-circle.svg';
  import Pause from '../style/assets/pause-circle.svg';

  export default {
    name: "PPButtonTogglePlayPause",
    components: {Play, Pause},
    mixins: [PPComponentMixin, PPPlayerMethodsMixin],
    computed: {
      playing () {
        if (this.player.ad.active) {
          return this.player.ad.playing;
        }
        return this.player.playing;
      }
    }
  }
</script>
